export function getCanonicalAffiliateName(profile, user) {
  const profileUsername = profile?.username?.trim();
  const profileEmail = profile?.email?.trim();
  const authEmail = user?.email?.trim();
  const metadataUsername = user?.user_metadata?.username?.trim();

  return (
    profileUsername ||
    profileEmail ||
    authEmail ||
    metadataUsername ||
    "user"
  );
}
